import { gql } from "@apollo/client";
const RANKING_DATES = gql`
  query leagueRankingsDate($filter: ListLeagueRankingInput) {
    leagueRankingsDate(filter: $filter) {
      date
    }
  }
`;
export default RANKING_DATES;
